import styled from "styled-components";
import {
    ContainerButtonHeaderType
} from "@dropDesk/presentation/pages/client/ui/my_clients/form/inputs_address/addresses";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";

type BorderType = {
    borderColor: string;
};
type IconOpsType = {
    background: string;
    color: string;
};
export const ContentData = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
export const SubContentInputs = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContentInput = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
export const ContentPickImage = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentDataInput = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContainerButtonNewUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 40px;
`;

export const ContentButtonNewUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 160px;
`;
export const ContainerDataInputs = styled.div<BorderType>`
  display: flex;
  border: 1px solid ${(props) => props.borderColor};
  padding: 16px;
  border-radius: 5px;
  flex-direction: column;
  overflow: auto;
  margin: 15px 0;
`;
export const ContainerListUser = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const ContentButtonActions = styled.div`
  display: flex;
  height: 40px;
  align-items: flex-start;
  justify-content: flex-end;
  flex-direction: row;
  margin-top: -10px;
`;

export const Icon = styled.i<IconOpsType>`
  color: ${props => props.color};
  font-size: 19px;
  padding: 2px 0;
  cursor: pointer;
  background: ${(props) => props.background};
  border-radius: 3px;

  &:hover {
    filter: brightness(80%);
  }

`;
export const ContentImage = styled.div`
  display: flex;
  width: 170px;
  align-items: flex-end;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
  margin-top: 10px;
`;

export const ContentNameAndImage = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const SubContentInputsListUsers = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ContentDataLogin = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ContentDataObservation = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;
export const ContainerButtonHeader = styled.div<ContainerButtonHeaderType>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 35px;
  min-width: 35px;
  max-width: 35px;
  height: 35px;
  min-height: 35px;
  max-height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
  margin: 0 2px;
  background: ${props => props.background};


  &:hover {
    background: ${props => props.background};
    border-color: transparent;
    box-shadow: 0 0 0 2px ${props => hexToRGBA(props.accent, .58)};
    outline: none;
    transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
  }
`;
